import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/ui/PageHeader.js";
import { DataTable, type Column } from "@/components/ui/DataTable.js";
import { StatusBadge } from "@/components/ui/StatusBadge.js";
import { api } from "@/lib/api.js";
import { relativeTime } from "@/lib/format.js";

interface Job {
  id: number;
  idcompany: number;
  reportType: string;
  status: string;
  requesterName: string | null;
  queuedAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  durationMs: number | null;
  errorMessage: string | null;
}

export function ReportingPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["reporting", "jobs"],
    queryFn: () => api.get<{ items: Job[] }>("/reporting/jobs?pageSize=100"),
    refetchInterval: 15_000,
  });

  const cols: Column<Job>[] = [
    { header: "Company", render: (r) => r.idcompany, width: "100px" },
    { header: "Reporte", render: (r) => <span className="mono text-xs">{r.reportType}</span> },
    { header: "Estado", render: (r) => <StatusBadge value={r.status} /> },
    { header: "Solicitado por", render: (r) => r.requesterName ?? "—" },
    { header: "En cola", render: (r) => relativeTime(r.queuedAt) },
    { header: "Finalizado", render: (r) => relativeTime(r.finishedAt) },
    {
      header: "Duración",
      render: (r) => (r.durationMs ? `${(r.durationMs / 1000).toFixed(1)}s` : "—"),
    },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Reportería"
        description="Refresh manual de reportes desfasados y estado de los jobs."
      />
      <DataTable
        columns={cols}
        rows={data?.items}
        loading={isLoading}
        getKey={(r) => r.id}
        empty="No hay jobs de refresh registrados."
      />
    </div>
  );
}
